export const openPopup = (
  url: string,
  width?: number,
  height?: number,
  target: string = '_blank',
): Window | null => {
  try {
    if (url.slice(0, 4) !== 'http') {
      url = `https://${url}`;
    }
    let popup: Window | null = null;

    if (width && height) {
      popup = window.open(url, target, `width=${width}, height=${height}, scrollbars=1`);
    } else {
      popup = window.open(url, target);
    }

    if (popup === null) {
      window.location.href = url;
    }

    return popup;
  } catch (err) {
    alert('팝업이 차단되어 페이지를 이동할 수 없습니다');
    return null;
  }
};
